import { ConnectComponent } from '../../_components/ConnectComponent'
import { TypeOfGoodsPresenter } from './TypeOfGoods.presenter'
import { TypeOfGoodsView } from './TypeOfGoods.view'

export const TypeOfGoods = ConnectComponent(
  TypeOfGoodsView,
  TypeOfGoodsPresenter,
)
